import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';

export class MailNotification extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {number}
   */
  userId;

  /**
   * @var {string}
   */
  deletedAt;

  /**
   * @var {string}
   */
  modelType;

  /**
   * @var {number}
   */
  modelId;

  /**
   * @relationship
   * @var {Document}
   */
  document;

  /**
   * @relationship
   * @var {EsignEnvelope}
   */
  esignEnvelope;

  constructor(model = {}) {
    super(model);
    super.setRelationships(this, model, this.getModelName());

    this.id = model.id;
    this.userId = model.userId;
    this.modelId = model.modelId;
    this.modelType = model.modelType;
    this.deletedAt = model.deletedAt;
  }

  /**
   *
   * @returns {string}
   */
  getModelName() {
    return ModelType.MAIL_NOTIFICATION;
  }
}
